<template>
  <div class="top">
    <ProfileCircle></ProfileCircle>
  </div>
</template>

<script>
import ProfileCircle from '../../commons/profile/circle/Circle'

export default {
  components: {
    ProfileCircle
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.top{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Patient/PatientCircles.vue